import { useContext, useEffect, useMemo, useState } from 'react';
import {
  CardHeader,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
} from 'reactstrap';
import api from 'services/api';
import { PropostaMaterialAvulso as IPropostaMaterialAvulso } from 'models/PropostaMaterialAvulso';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FaTrash } from 'react-icons/fa';
import { Checkbox, CircularProgress, Tooltip } from '@material-ui/core';
import toast from 'react-hot-toast';
import { PropostaContext } from 'views/pages/Proposta';
import { useQuery } from 'react-query';
import formatCurrency from 'utils/formatCurrency';
import mensagemAtingirMeta from 'utils/mensagemAtingirMeta';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import traduzirNomeMaterial from 'utils/traduzirNomeMaterial';
import { Th, Td, Tr, Descricao } from './styles';
import { IMateriaisImportados, MateriaisContext } from '../..';

interface props {
  materiaisImportados: IMateriaisImportados[];
  propostaVersaoId: number;
  campoBusca: string;
  isFaturamentoDireto: boolean;
  checkedIdsImportados: Set<number>;
  setCheckedIdsImportados: React.Dispatch<React.SetStateAction<Set<number>>>;
  marcarTodosComoFatDir: boolean;
  setMarcarTodosComoFatDir: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function PropostaMaterialImportado({
  materiaisImportados,
  propostaVersaoId,
  campoBusca,
  isFaturamentoDireto,
  checkedIdsImportados,
  setCheckedIdsImportados,
  marcarTodosComoFatDir,
  setMarcarTodosComoFatDir,
}: props): JSX.Element {
  const { propostaVersao, setPrecosDesatualizados } =
    useContext(PropostaContext);

  const { triggerUpdateMaterial } = useContext(MateriaisContext);

  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [acessoLimitadoListaMateriais, setAcessoLimitadoListaMateriais] =
    useState(true);
  const [idsFiltrados, setIdsFiltrados] = useState<number[]>([]);

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 60,
      },
    });

    setAcessoLimitadoListaMateriais(response.data);
  }

  useEffect(() => {
    if (isSaving) {
      toast.loading('Excluindo registro', { position: 'top-right' });
    } else {
      toast.dismiss();
    }
  }, [isSaving]);

  useEffect(() => {
    getAcessoLimitadoPrograma();
  }, []);

  useEffect(() => {
    if (propostaVersao.id) {
      //
    }
  }, [propostaVersao]);

  function handleOnAddFinanciamentoDiretoImportado(
    propostaMaterialImportado: any,
  ) {
    setCheckedIdsImportados(prev => {
      const newSet = new Set(prev);
      if (newSet.has(propostaMaterialImportado.id)) {
        newSet.delete(propostaMaterialImportado.id);
      } else {
        newSet.add(propostaMaterialImportado.id);
      }
      return newSet;
    });
  }

  async function deletarImportacao(item: any) {
    const confirmacao = await Swal.fire({
      title: `Atenção`,
      html: `Ao prosseguir, você estará excluindo esse registro de importação da proposta. A operação não poderá ser revertida. Deseja continuar?`,
      icon: 'warning',
      confirmButtonText: `Sim, prosseguir`,
      cancelButtonText: `Não`,
      showCancelButton: true,
    });

    const resultado = confirmacao.isConfirmed;

    if (resultado) {
      setIsSaving(true);
      // Disparar exclusão
      await api.delete(
        `/proposta/versao/${propostaVersao.id}/material-importado/${item.id}`,
      );
      setIsSaving(false);
      if (propostaVersaoId) {
        await mensagemAtingirMeta(
          `Foi removido um equipamento importado da proposta`,
          Number(propostaVersaoId),
        );
      }

      toast.success('Registro excluído com sucesso');
      triggerUpdateMaterial();
    }
  }

  const materiaisFiltrados = useMemo(() => {
    if (!materiaisImportados?.length) return [];

    const agrupado = materiaisImportados[0]?.agrupado;

    const val =
      campoBusca === ''
        ? agrupado
        : agrupado
            .map(val2 =>
              val2.materiais.filter(
                val3 =>
                  val3.material.descricaoFabrSge === campoBusca.toUpperCase(),
              ),
            )
            .filter(val4 => val4.length > 0);

    return val;
  }, [materiaisImportados, campoBusca]);

  useEffect(() => {
    if (materiaisFiltrados.length > 0 && campoBusca !== '') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const ids = materiaisFiltrados.flat().map(item => item.id);

      setIdsFiltrados(ids);

      if (marcarTodosComoFatDir) {
        const idsUsar = new Set([...ids, ...idsFiltrados]);
        Array.from(idsUsar).map(item => {
          setCheckedIdsImportados(prev => {
            const newSet = new Set(prev);
            if (newSet.has(item)) {
              newSet.delete(item);
            } else {
              newSet.add(item);
            }
            return newSet;
          });
          return null;
        });
        setMarcarTodosComoFatDir(false);
      }
    }
    // else if (campoBusca === '') {
    // setIdsFiltrados([]);
    // }
  }, [materiaisFiltrados, marcarTodosComoFatDir]);

  function Materiais(item: any[]): JSX.Element {
    if (!item.length) {
      return (
        <tr>
          <Td className="text-center" colSpan={5}>
            Nenhum registro encontrado
          </Td>
        </tr>
      );
    }

    return (
      <>
        {item.map((materialAvulso: any) => {
          const {
            id,
            produtoAtividade,
            valor,
            quantidade,
            valorTotal,
            material,
          } = materialAvulso;

          return (
            <Tr semPreco={valor === 0}>
              <Td>
                {produtoAtividade
                  ? traduzirProdutoAtividade(produtoAtividade, true)
                  : ''}
              </Td>
              <Td>
                <Descricao>{traduzirNomeMaterial(material)}</Descricao>
              </Td>
              <Td className="text-center">{quantidade}</Td>
              <Td className="text-right" hidden={acessoLimitadoListaMateriais}>
                {formatCurrency(valor)}
              </Td>
              <Td className="text-right" hidden={acessoLimitadoListaMateriais}>
                {formatCurrency(valorTotal)}
              </Td>
              {isFaturamentoDireto && (
                <Td className="text-center w-auto">
                  <Checkbox
                    color="primary"
                    className="mr-1 float-center"
                    checked={checkedIdsImportados.has(materialAvulso.id)}
                    title="Faturamento Direto"
                    onChange={() =>
                      handleOnAddFinanciamentoDiretoImportado(materialAvulso)
                    }
                  />
                </Td>
              )}
            </Tr>
          );
        })}
      </>
    );
  }

  function Atividade(item: any[]): JSX.Element {
    if (!item.length) {
      return (
        <tr>
          <Td className="text-center" colSpan={5}>
            Nenhum registro encontrado
          </Td>
        </tr>
      );
    }

    let itemFiltrado = item;
    if (campoBusca) {
      itemFiltrado = item
        .map(val => ({
          ...val,
          materiais: val.materiais.filter(
            (obj: any) =>
              obj.material.descricaoFabrSge === campoBusca.toUpperCase(),
          ),
        }))
        .filter(val => val.materiais.length > 0);
    }

    return (
      <>
        {itemFiltrado.map((materialAvulso: any) => {
          const atividadeGrupo = materialAvulso.materiais[0].produtoAtividade;

          const atividade = atividadeGrupo
            ? traduzirProdutoAtividade(atividadeGrupo, true)
            : '';

          return (
            <>
              {Materiais(materialAvulso.materiais)}
              <Tr id={`total_${materialAvulso.atividade}`}>
                <Td colSpan={3} />
                <Td
                  className="text-right"
                  hidden={acessoLimitadoListaMateriais || campoBusca !== ''}
                >
                  <h3>Total Atividade {atividade}</h3>
                </Td>
                <Td
                  className="text-right"
                  hidden={acessoLimitadoListaMateriais || campoBusca !== ''}
                >
                  <h3>{formatCurrency(materialAvulso.total ?? 0, 2)}</h3>
                </Td>
              </Tr>
            </>
          );
        })}
      </>
    );
  }
  function getTipoHeader(tipo: any) {
    if (String(tipo.tipoImportacao).toUpperCase() === 'OUTROS') {
      return tipo.finalidade ?? '';
    }
    if (String(tipo.tipoImportacao).toUpperCase() === 'BM') {
      return 'Bombeamento Mestre';
    }

    return tipo.tipo;
  }

  function Header(item: any): JSX.Element {
    return (
      <>
        <CardHeader>
          <Row>
            <Col sm="8">
              <h4 className="mb--1">
                {getTipoHeader(item)} | {item.titulo} |{' '}
                <span style={{ fontSize: '0.7em' }}>{item.data}</span>
              </h4>
              <small className="text-muted"> </small>
            </Col>
            <Col sm="4">
              <Button
                outline
                className="btn-icon btn-2 ml-1 float-right"
                color="danger"
                type="button"
                size="sm"
                disabled={isSaving}
                onClick={() => deletarImportacao(item)}
              >
                <FaTrash />
              </Button>
              <div className="float-right mr-2" style={{ fontSize: '0.7em' }}>
                <strong>Arquivo de importação:</strong>
                <br />
                {item.nomeArquivo}
              </div>
            </Col>
          </Row>
        </CardHeader>

        <Card>
          <CardBody className="p-1">
            {loading ? (
              <Row>
                <Col className="text-center mb-4 mt-4">
                  <CircularProgress />
                </Col>
              </Row>
            ) : (
              <Table bordered responsive>
                <thead>
                  <tr>
                    <Th>Ativ</Th>
                    <Th>Item</Th>
                    <Th className="text-center">Quantidade</Th>
                    {!acessoLimitadoListaMateriais && (
                      <>
                        <Th className="text-right">Valor unitário</Th>
                        <Th className="text-right">Valor total</Th>
                      </>
                    )}
                    {isFaturamentoDireto && (
                      <Th
                        className="text-center w-auto"
                        style={{ width: '80px' }}
                      >
                        <Tooltip title="Financiamento Direto">
                          <span>Fat. Direto</span>
                        </Tooltip>
                      </Th>
                    )}
                  </tr>
                </thead>
                <tbody>{Atividade(item.agrupado)}</tbody>
                <tfoot
                  hidden={acessoLimitadoListaMateriais || campoBusca !== ''}
                >
                  <tr>
                    <td colSpan={3} />
                    <td className="text-right">
                      <h2>Total Materiais:</h2>{' '}
                    </td>
                    <td className="text-right">
                      <h2>{formatCurrency(item.valorTotal, 2)}</h2>
                    </td>
                  </tr>
                </tfoot>
              </Table>
            )}
          </CardBody>
        </Card>
      </>
    );
  }

  return <>{materiaisImportados.map(item => Header(item))}</>;
}
